import * as React from 'react';
import { useContext } from 'react';

// This context holds info relating to the users relationship to the current product within the current program.
type EnterpriseUserProductInfoContextType = {
  isWishlisted?: boolean;
  isEnrolled?: boolean;
  // True if the user is enrolled in the product via some other context (consumer, another program), but is not in the current program.
  isEnrolledOutsideOfProgram?: boolean;
  // True if the user is soft-deleted / "auditing" the product. Learners are put in this state after enrolling in a product via program
  // and then being removed from all programs that offer the product. They have access to content, but no graded items/completion credit.
  isAuditing?: boolean;
};

const EnterpriseUserProductInfoContext = React.createContext<EnterpriseUserProductInfoContextType>({});

export const useIsWishlisted = () => {
  const userProductInfo = useContext(EnterpriseUserProductInfoContext);

  return userProductInfo.isWishlisted;
};

export const useIsEnrolled = () => {
  const userProductInfo = useContext(EnterpriseUserProductInfoContext);

  return userProductInfo.isEnrolled;
};

export const useIsEnrolledOutsideOfProgram = () => {
  const userProductInfo = useContext(EnterpriseUserProductInfoContext);

  return userProductInfo.isEnrolledOutsideOfProgram;
};

export const useIsAuditing = () => {
  const userProductInfo = useContext(EnterpriseUserProductInfoContext);

  return userProductInfo.isAuditing;
};

export default EnterpriseUserProductInfoContext;
